<template>
  <div>这是B页面<h1>内容</h1>
    <h1>内容</h1>
    <h1>内容</h1>
    <h1>内容</h1>
    <h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1>
    <h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1>
    <h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1>
    <h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1><h1>内容</h1>

  </div>
</template>

<script>
export default {
  name: "standardB"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/veiws/standardB.vue